import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getLeague, saveLeague } from "./../../services/leagueService";

class LeagueForm extends Form {
  state = {
    data: { id: -1, name: "", addInf: "" },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required(),
    addInf: Joi.string().allow("")
  };

  async componentDidMount() {
    const { match, history } = this.props;

    const leagueId = match.params.id;
    if (leagueId === "new") return;

    const league = await getLeague(leagueId);
    if (!league) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(league) });
  }

  mapToViewModel(league) {
    return {
      id: league.id,
      name: league.name,
      addInf: league.addInf
    };
  }

  doSubmit = async () => {
    await saveLeague(this.state.data);
    this.props.history.push("/leagues");
  };

  render() {
    return (
      <div>
        <h2>League</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink("/leagues", "fa fa-arrow-left", "btn btn-secondary")}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("name", "Name", true)}
          {this.renderInput("addInf", "Add. Inf.")}
        </form>
      </div>
    );
  }
}

export default LeagueForm;



// WEBPACK FOOTER //
// ./src/components/leagues/leagueForm.jsx